var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "baseScrollContainer",
      staticClass: "base-scroll-container",
      class: { "base-scroll-container--in-modal": _vm.isInModal }
    },
    [
      _c(
        "div",
        {
          ref: "baseScrollBody",
          staticClass: "base-scroll-container__body",
          class: {
            "base-scroll-container__body--fixed-header": _vm.isHeaderFixed,
            "base-scroll-container__body--fixed-footer": _vm.isFooterFixed,
            "base-scroll-container__body--in-modal": _vm.isInModal
          },
          style: {
            maxHeight: _vm.scrollContainerBodyHeight + "px"
          },
          on: { scroll: _vm.amountScrolled }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }